(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["techaf-foundation"] && !Shopify.designMode) return;
  try {
    document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  document.addEventListener('change', (event) => {
    const selector = event.target.closest('[data-techaf-variant-select]');
    if (!selector) return;
    const root = selector.closest('[data-techaf-product]');
    const option = selector.options[selector.selectedIndex];
    const price = root.querySelector('[data-techaf-price]');
    const button = root.querySelector('[data-techaf-add]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (button) {
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? button.dataset.availableLabel : button.dataset.soldLabel;
    }
    const mediaId = option.dataset.mediaId;
    if (mediaId) {
      const target = root.querySelector(`[data-techaf-media="${mediaId}"]`);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', selector.value);
    window.history.replaceState({}, '', url);
  });

  document.addEventListener('click', (event) => {
    const thumbnail = event.target.closest('[data-techaf-thumbnail]');
    if (!thumbnail) return;
    const root = thumbnail.closest('[data-techaf-product]');
    const target = root.querySelector(`[data-techaf-media="${thumbnail.dataset.techafThumbnail}"]`);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  });
  } catch(e) { console.error(e); }
})();

})();
